<mat-card class="card-narrow">
  <mat-card-header>
    <mat-card-title>Log In</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="d-flex justify-content-center" *ngIf="loggingIn">
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!loggingIn">
      <form [formGroup]="loginForm">
        <mat-form-field>
          <mat-label>Username</mat-label>
          <input matInput maxlength="50" formControlName="username" type="text" autocomplete="username"/>
          <mat-error *ngIf="loginForm.controls.username.errors?.['required']">Username is required</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" [type]="hidePassword() ? 'password' : 'text'" autocomplete="current-password"/>
          <button matSuffix mat-icon-button aria-label="Show Password" (click)="togglePasswordVisibility($event)">
            <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="loginForm.controls.password.errors?.['required']">Password is required</mat-error>
        </mat-form-field>

        <!-- Terms and conditions checkbox with <A> dialog -->
        <div class="form-item d-flex">
          <mat-checkbox class="flex-1" formControlName="termsAndConditions">
              <div>
                I have read and agree to the
                <a routerLink="" class="link-button" (click)="openTermsAndConditionsDialog()">
                  Terms and Conditions
                </a>
              </div>
              @if(loginFormSubmitted && loginForm.controls.termsAndConditions.errors?.['required']){
                <mat-error *ngIf="loginFormSubmitted && loginForm.controls.termsAndConditions.errors?.['required']">
                  {{"You must agree to the terms and conditions"}}
                </mat-error>
                }
          </mat-checkbox>


        </div>

        <div class="d-flex form-item">
          <button class="flex-1" mat-flat-button (click)="login()">Login</button>
        </div>
        @if(errorMessage){
          <div class="d-flex form-item justify-content-center">
            <mat-error class="label-text" *ngIf="errorMessage">
              {{ errorMessage }}
            </mat-error>
          </div>
        }

        <div class="d-flex justify-content-center">
          <a class="link-button" routerLink="/forgot-password">Forgot Password?</a>
        </div>
      </form>

      <div class="label-text justify-content-center">
        Please do not forget to logout before closing the portal.
      </div>

      <div class="d-flex justify-content-center">
        <a routerLink="" class="link-button" (click)="openDataSecurityAndPrivacyDialog()">About Data Security and Privacy</a>
      </div>

    </div>
  </mat-card-content>
</mat-card>
